import React from 'react';
import { Layout } from '../components/Layout';
import { useAuth } from '../hooks/useAuth';

export function Home() {
  const { user } = useAuth();

  return (
    <Layout>
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Good to have you back{user?.email ? `, ${user.email.split('@')[0]}` : ''}.
        </p>
      </div>
    </Layout>
  );
}
